const initVideo = (): void => {
  const video = document.querySelector<HTMLVideoElement>('[data-hero-video]');

  if (!video || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  video.autoplay = false;
  video.loop = false;
  video.controls = true;
  video.pause();
};

const init = (): void => {
  initVideo();

  const cta = document.querySelector<HTMLAnchorElement>('.hero__cta');

  if (!cta) {
    return;
  }

  cta.addEventListener('click', (event) => {
    const target = cta.getAttribute('href');

    if (!target || !target.startsWith('#')) {
      return;
    }

    const destination = document.querySelector(target);

    if (!destination) {
      return;
    }

    event.preventDefault();
    destination.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

export {};
